<template>
    <div id="insight_preferences">
        <div class="d-flex">
            <img src="/img/icons/nav-icons/Insights.svg" alt="Insight Preferences" class="card-icon">
            <div class="ms-3 flex-grow-1">
                <div class="d-flex align-items-center justify-content-between">
                    <h3 class="mb-0">Insight Preferences</h3>
                </div>
                <p class="mb-0">Control how your Insight reports are displayed.</p>
            </div>
        </div>

        <div class="row mt-4">
            <div class="col-12 form-check form-switch d-inline-flex align-items-center gap-2 mb-3">
                <input
                    id="show-compressed-numbers"
                    class="form-check-input mt-0 me-2"
                    type="checkbox"
                    role="switch"
                    v-model="showCompressedNumbers"
                    @change="onToggle"
                 aria-label="Checkbox">
                <label class="form-check-label mb-0" for="show-compressed-numbers">
                    Show compressed numbers on charts
                </label>
            </div>
            <div class="col-12 form-check form-switch d-inline-flex align-items-center gap-2 mb-3">
                <input
                    id="hide-ai-summaries"
                    class="form-check-input mt-0 me-2"
                    type="checkbox"
                    role="switch"
                    v-model="showAiSummaries"
                    @change="onToggle"
                 aria-label="Checkbox">
                <label class="form-check-label mb-0" for="hide-ai-summaries">
                    Show AI summaries
                </label>
            </div>
        </div>
    </div>
</template>

<script>
import { defineComponent } from 'vue';
import { useNotifications } from '../../../composables/useNotifications';
import { useUserStore } from '../../../stores/user';

export default defineComponent({
    name: 'InsightPreferences',
    setup() {
        const { showNotification } = useNotifications();
        const userStore = useUserStore();
        return { showNotification, userStore };
    },
    props: {
        user: {
            type: Object,
            required: true
        }
    },
    data() {
        const prefs = this.user?.preferences ?? {};
        const prefsNull = this.user?.preferences == null;
        return {
            showCompressedNumbers: prefsNull ? true : (prefs.show_compressed_numbers !== false),
            showAiSummaries: prefsNull ? true : (prefs.show_ai_summaries !== false),
            form: {
                busy: false,
                lastSaved: false
            }
        };
    },
    watch: {
        'user.preferences': {
            deep: true,
            handler(prefs) {
                if (prefs == null) {
                    this.showCompressedNumbers = true;
                    this.showAiSummaries = true;
                    return;
                }
                this.showCompressedNumbers = prefs.show_compressed_numbers !== false;
                this.showAiSummaries = prefs.show_ai_summaries !== false;
            }
        }
    },
    methods: {
        onToggle() {
            this.savePreferences();
        },
        savePreferences() {
            const self = this;
            this.form.busy = true;
            this.form.lastSaved = false;

            const updatedPreferences = {
                show_compressed_numbers: this.showCompressedNumbers,
                show_ai_summaries: this.showAiSummaries
            };

            window.axios.put(`/api/user/${this.user.id}/preferences`, {
                preferences: updatedPreferences
            }).then(() => {
                self.form.busy = false;
                self.form.lastSaved = true;

                const currentPrefs = self.user?.preferences ?? {};
                const mergedPreferences = { ...currentPrefs, ...updatedPreferences };
                self.userStore.updateUser({ preferences: mergedPreferences });

                self.showNotification({ text: 'Insight preferences saved.' });
                setTimeout(() => { self.form.lastSaved = false; }, 3000);
            })
            .catch(() => {
                self.form.busy = false;
                self.showNotification({
                    text: 'Failed to save insight preferences. Please try again.',
                    type: 'error'
                });
            });
        }
    }
});
</script>
